import { INTEGRATION_KEYS } from './integration-items'

export const CATEGORY_KEYS = {
  all: 'all',
  mostPopular: 'most_popular',
  videoConferencing: 'video_conferencing',
  calendars: 'calendars',
  extensionsAndApps: 'extensions_and_apps',
  salesAndCrm: 'sales_and_crm',
  marketing: 'marketing',
  emailMessaging: 'email_messaging',
  analytics: 'analytics',
  embedCalendly: 'embed_calendly',
  payments: 'payments',
  securityAndCompliance: 'security_and_compliance',
  apiAndConnectors: 'api_and_connectors',
  adminManaged: 'admin_managed',
  integrations: 'integrations'
}

const ALL_ITEMS = Object.values(INTEGRATION_KEYS)
export const VIDEO_CONFERENCING_ITEMS = [
  INTEGRATION_KEYS.zoom,
  INTEGRATION_KEYS.googleMeet,
  INTEGRATION_KEYS.microsoftTeams,
  INTEGRATION_KEYS.gotomeeting,
  INTEGRATION_KEYS.webex,
]
const EXTENSIONS_AND_APPS_ITEMS = [
  INTEGRATION_KEYS.iphoneApp,
  INTEGRATION_KEYS.chrome,
  INTEGRATION_KEYS.androidApp,
  INTEGRATION_KEYS.outlookExtension,
  INTEGRATION_KEYS.slack,
  INTEGRATION_KEYS.lever,
  INTEGRATION_KEYS.linkedin,
  INTEGRATION_KEYS.firefox,
  INTEGRATION_KEYS.edge,
  INTEGRATION_KEYS.safari,
  INTEGRATION_KEYS.intercom,
  INTEGRATION_KEYS.microsoftTeamsChat,
]
const SALES_AND_CRM_ITEMS = [
  INTEGRATION_KEYS.salesforce,
  INTEGRATION_KEYS.hubspot,
  INTEGRATION_KEYS.microsoftDynamics,
  INTEGRATION_KEYS.linkedin,
  INTEGRATION_KEYS.gong
]
const MARKETING_ITEMS = [
  INTEGRATION_KEYS.googleAnalytics,
  INTEGRATION_KEYS.facebookPixel,
  INTEGRATION_KEYS.marketo,
  INTEGRATION_KEYS.hubspot,
  INTEGRATION_KEYS.pardot,
  INTEGRATION_KEYS.mailchimp,
  INTEGRATION_KEYS.intercom,
]
const EMAIL_MESSAGING_ITEMS = [
  INTEGRATION_KEYS.gmail,
  INTEGRATION_KEYS.outlook,
  INTEGRATION_KEYS.mailchimp,
]
const ANALYTICS_ITEMS = [
  INTEGRATION_KEYS.googleAnalytics,
  INTEGRATION_KEYS.facebookPixel,
]
const EMBED_CALENDLY_ITEMS = [
  INTEGRATION_KEYS.wordpress,
  INTEGRATION_KEYS.squarespace,
  INTEGRATION_KEYS.intercom,
  INTEGRATION_KEYS.wix,
]
const PAYMENT_ITEMS = [
  INTEGRATION_KEYS.stripe,
  INTEGRATION_KEYS.paypal,
]
export const SECURITY_AND_COMPLIANCE_ITEMS = [
  INTEGRATION_KEYS.okta,
  INTEGRATION_KEYS.microsoftAzure,
  INTEGRATION_KEYS.oneLogin,
  INTEGRATION_KEYS.pingIdentity,
  INTEGRATION_KEYS.duo,
  INTEGRATION_KEYS.ssoAndScim,
]
const API_AND_CONNECTORS_ITEMS = [
  INTEGRATION_KEYS.zapier,
  INTEGRATION_KEYS.apiWebhooks,
  INTEGRATION_KEYS.microsoftPowerAutomate
]
const MOST_POPULAR_ITEMS = [
  INTEGRATION_KEYS.googleCalendar,
  INTEGRATION_KEYS.office365,
  INTEGRATION_KEYS.zoom,
  INTEGRATION_KEYS.googleMeet,
  INTEGRATION_KEYS.iphoneApp,
  INTEGRATION_KEYS.chrome,
  INTEGRATION_KEYS.microsoftTeams,
  INTEGRATION_KEYS.androidApp,
  INTEGRATION_KEYS.googleAnalytics,
  INTEGRATION_KEYS.salesforce,
]
export const CALENDAR_ITEMS = [
  INTEGRATION_KEYS.googleCalendar,
  INTEGRATION_KEYS.office365,
  INTEGRATION_KEYS.office365Outlook,
  INTEGRATION_KEYS.office365OutlookOrganization,
  INTEGRATION_KEYS.icloudCalendar,
  INTEGRATION_KEYS.outlookCalendar,
  INTEGRATION_KEYS.exchangeCalendar,
]
const ADMIN_MANAGED_ITEMS = [
  INTEGRATION_KEYS.hubspot,
  INTEGRATION_KEYS.mailchimp,
  INTEGRATION_KEYS.salesforce,
  INTEGRATION_KEYS.lever,
  INTEGRATION_KEYS.googleAnalytics,
  INTEGRATION_KEYS.facebookPixel,
  INTEGRATION_KEYS.okta,
  INTEGRATION_KEYS.microsoftAzure,
  INTEGRATION_KEYS.oneLogin,
  INTEGRATION_KEYS.pingIdentity,
  INTEGRATION_KEYS.duo,
  INTEGRATION_KEYS.ssoAndScim,
  INTEGRATION_KEYS.marketo,
  INTEGRATION_KEYS.pardot,
  INTEGRATION_KEYS.microsoftDynamics,
  INTEGRATION_KEYS.microsoftPowerAutomate
]
const INTEGRATION_ITEMS = [
  ...VIDEO_CONFERENCING_ITEMS,
  ...CALENDAR_ITEMS,
  ...SALES_AND_CRM_ITEMS,
  ...ANALYTICS_ITEMS,
  ...SECURITY_AND_COMPLIANCE_ITEMS,
]

export const CATEGORIES = {
  [CATEGORY_KEYS.all]: {
    key: CATEGORY_KEYS.all,
    integrations: ALL_ITEMS,
  },
  [CATEGORY_KEYS.mostPopular]: {
    key: CATEGORY_KEYS.mostPopular,
    integrations: MOST_POPULAR_ITEMS,
  },
  [CATEGORY_KEYS.videoConferencing]: {
    key: CATEGORY_KEYS.videoConferencing,
    integrations: VIDEO_CONFERENCING_ITEMS,
  },
  [CATEGORY_KEYS.calendars]: {
    key: CATEGORY_KEYS.calendars,
    integrations: CALENDAR_ITEMS,
  },
  [CATEGORY_KEYS.extensionsAndApps]: {
    key: CATEGORY_KEYS.extensionsAndApps,
    integrations: EXTENSIONS_AND_APPS_ITEMS,
  },
  [CATEGORY_KEYS.salesAndCrm]: {
    key: CATEGORY_KEYS.salesAndCrm,
    integrations: SALES_AND_CRM_ITEMS,
  },
  [CATEGORY_KEYS.marketing]: {
    key: CATEGORY_KEYS.marketing,
    integrations: MARKETING_ITEMS,
  },
  [CATEGORY_KEYS.emailMessaging]: {
    key: CATEGORY_KEYS.emailMessaging,
    integrations: EMAIL_MESSAGING_ITEMS
  },
  [CATEGORY_KEYS.analytics]: {
    key: CATEGORY_KEYS.analytics,
    integrations: ANALYTICS_ITEMS
  },
  [CATEGORY_KEYS.embedCalendly]: {
    key: CATEGORY_KEYS.embedCalendly,
    integrations: EMBED_CALENDLY_ITEMS
  },
  [CATEGORY_KEYS.payments]: {
    key: CATEGORY_KEYS.payments,
    integrations: PAYMENT_ITEMS,
  },
  [CATEGORY_KEYS.securityAndCompliance]: {
    key: CATEGORY_KEYS.securityAndCompliance,
    integrations: SECURITY_AND_COMPLIANCE_ITEMS,
  },
  [CATEGORY_KEYS.apiAndConnectors]: {
    key: CATEGORY_KEYS.apiAndConnectors,
    integrations: API_AND_CONNECTORS_ITEMS,
  },
}

const INTEGRATION_CATEGORIES = [
  CATEGORY_KEYS.videoConferencing,
  CATEGORY_KEYS.calendars,
  CATEGORY_KEYS.salesAndCrm,
  CATEGORY_KEYS.marketing,
  CATEGORY_KEYS.emailMessaging,
  CATEGORY_KEYS.payments,
  CATEGORY_KEYS.analytics,
  CATEGORY_KEYS.securityAndCompliance,
]

const ONBOARDING_MOST_POPULAR_SHORT_LIST_ITEMS = [
  INTEGRATION_KEYS.zoom,
  INTEGRATION_KEYS.salesforce,
  INTEGRATION_KEYS.googleMeet,
  INTEGRATION_KEYS.hubspot,
  INTEGRATION_KEYS.googleCalendar,
  INTEGRATION_KEYS.outlookCalendar,
  INTEGRATION_KEYS.microsoftTeams,
  INTEGRATION_KEYS.chrome,
  INTEGRATION_KEYS.stripe,
  INTEGRATION_KEYS.zapier,
  INTEGRATION_KEYS.paypal,
  INTEGRATION_KEYS.slack,
]

const ONBOARDING_MOST_POPULAR_ITEMS = [
  ...ONBOARDING_MOST_POPULAR_SHORT_LIST_ITEMS,
  INTEGRATION_KEYS.apiWebhooks,
  INTEGRATION_KEYS.iphoneApp,
  INTEGRATION_KEYS.androidApp,
  INTEGRATION_KEYS.microsoftTeamsChat,
  INTEGRATION_KEYS.microsoftDynamics,
  INTEGRATION_KEYS.exchangeCalendar,
  INTEGRATION_KEYS.icloudCalendar,
  INTEGRATION_KEYS.gmail,
  INTEGRATION_KEYS.outlook,
  INTEGRATION_KEYS.office365,
  INTEGRATION_KEYS.office365Outlook,
  INTEGRATION_KEYS.office365OutlookOrganization,
  INTEGRATION_KEYS.microsoftPowerAutomate,
  INTEGRATION_KEYS.googleAnalytics,
  INTEGRATION_KEYS.facebookPixel,
  INTEGRATION_KEYS.marketo,
  INTEGRATION_KEYS.ssoAndScim,
  INTEGRATION_KEYS.linkedin,
  INTEGRATION_KEYS.gong,
  INTEGRATION_KEYS.mailchimp,
  INTEGRATION_KEYS.firefox,
  INTEGRATION_KEYS.outlookExtension,
  INTEGRATION_KEYS.intercom,
  INTEGRATION_KEYS.pardot,
  INTEGRATION_KEYS.okta,
  INTEGRATION_KEYS.microsoftAzure,
  INTEGRATION_KEYS.edge,
  INTEGRATION_KEYS.webex,
  INTEGRATION_KEYS.squarespace,
  INTEGRATION_KEYS.wix,
  INTEGRATION_KEYS.wordpress,
  INTEGRATION_KEYS.gotomeeting,
  INTEGRATION_KEYS.lever,
  INTEGRATION_KEYS.duo,
  INTEGRATION_KEYS.oneLogin,
  INTEGRATION_KEYS.pingIdentity,
]

export const ONBOARDING_CATEGORIES = {
  [CATEGORY_KEYS.mostPopular]: {
    key: CATEGORY_KEYS.mostPopular,
    integrations: ONBOARDING_MOST_POPULAR_ITEMS,
  },
  [CATEGORY_KEYS.all]: {
    key: CATEGORY_KEYS.all,
    integrations: ALL_ITEMS,
  },
  [CATEGORY_KEYS.integrations]: {
    key: CATEGORY_KEYS.integrations,
    integrations: INTEGRATION_ITEMS,
  },
  [CATEGORY_KEYS.videoConferencing]: {
    key: CATEGORY_KEYS.videoConferencing,
    integrations: VIDEO_CONFERENCING_ITEMS,
  },
  [CATEGORY_KEYS.calendars]: {
    key: CATEGORY_KEYS.calendars,
    integrations: CALENDAR_ITEMS,
  },
  [CATEGORY_KEYS.salesAndCrm]: {
    key: CATEGORY_KEYS.salesAndCrm,
    integrations: SALES_AND_CRM_ITEMS,
  },
  [CATEGORY_KEYS.marketing]: {
    key: CATEGORY_KEYS.marketing,
    integrations: MARKETING_ITEMS,
  },
  [CATEGORY_KEYS.emailMessaging]: {
    key: CATEGORY_KEYS.emailMessaging,
    integrations: EMAIL_MESSAGING_ITEMS
  },
  [CATEGORY_KEYS.payments]: {
    key: CATEGORY_KEYS.payments,
    integrations: PAYMENT_ITEMS,
  },
  [CATEGORY_KEYS.analytics]: {
    key: CATEGORY_KEYS.analytics,
    integrations: ANALYTICS_ITEMS
  },
  [CATEGORY_KEYS.securityAndCompliance]: {
    key: CATEGORY_KEYS.securityAndCompliance,
    integrations: SECURITY_AND_COMPLIANCE_ITEMS,
  },
  [CATEGORY_KEYS.adminManaged]: {
    key: CATEGORY_KEYS.adminManaged,
    integrations: ADMIN_MANAGED_ITEMS,
  },
  [CATEGORY_KEYS.extensionsAndApps]: {
    key: CATEGORY_KEYS.extensionsAndApps,
    integrations: EXTENSIONS_AND_APPS_ITEMS,
  },
  [CATEGORY_KEYS.embedCalendly]: {
    key: CATEGORY_KEYS.embedCalendly,
    integrations: EMBED_CALENDLY_ITEMS
  },
  [CATEGORY_KEYS.apiAndConnectors]: {
    key: CATEGORY_KEYS.apiAndConnectors,
    integrations: API_AND_CONNECTORS_ITEMS,
  }
}

export const CATEGORY_KEY_DFLT = CATEGORY_KEYS.all
export const ONBOARDING_CATEGORY_KEY_DFLT = CATEGORY_KEYS.mostPopular

export const isIntegrationCategory = (c) => INTEGRATION_CATEGORIES.includes(c)
export const isMostPopularShortListCategory = (c) => ONBOARDING_MOST_POPULAR_SHORT_LIST_ITEMS.includes(c)
